import { updateFiltersFront, setKeyFilterSelected } from "../../../redux/actions/visitActions";
import connect from "react-redux/es/connect/connect";
import Filter from "../../../components/filter/Filter";

const mapStateToProps = (state, ownProps) => {
  return {
    filters:
      state.visit && state.visit.filters && Array.isArray(state.visit.filters[ownProps.filterTargetKey])
        ? state.visit.filters[ownProps.filterTargetKey]
        : [],
    currentFilters: state.visit.currentFilters ? state.visit.currentFilters[ownProps.filterTargetKey] : [],
    deps: ownProps.depKey && state.visit.currentFilters ? state.visit.currentFilters[ownProps.depKey] || [] : [],
    filterTargetKey: ownProps.filterTargetKey,
    placeholder: ownProps.placeholder
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addFilter: values => {
      dispatch(updateFiltersFront(ownProps.filterTargetKey, values));
    },
    setKeyFilterSelected: () => dispatch(setKeyFilterSelected(ownProps.filterTargetKey))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Filter);



// WEBPACK FOOTER //
// src/containers/activite/visit/FilterContainer.js